<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre2" id="calibre_pb_0"></div>
<h1 class="p_heading_" id="auto_bookmark_toc_1"><span class="calibre1">Acknowledgments</span></h1>
<p class="p_normal"> </p>
<p class="p_normal"> </p>
<p class="p_norm-noindent"><span class="calibre3">THANKS TO</span> Alisha Klauger and Christine DeLuna for reading early drafts and letting me know when I was on the right track and on the wrong one.</p>
<p class="p_normal">Thanks to the real Julia Madden for being my sister.</p>
<p class="p_normal">As always thanks to Danny, Drew, Justin, Matthew, Vita, Emma, and Carson, just because.</p>
<p class="p_normal"> </p>
<p class="p_normal">Many, many thanks to everyone at Harmony Ink and Dreamspinner: Anne, Dawn, Jaime, Janet, and everyone there. Thank you. Thank you. Thank you.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0004.vue?c918c048